import EffiePattern from "@components/EffiePattern"
import React, { FC } from "react"
import { Container } from "@components/styles"
import { ContentCardWrapper, StyledEffiePatternWrapper, Content } from "./styles"
import { ContentBlockProps } from "./types"

const ContentCard: FC<ContentBlockProps> = ({
    content,
    width
}) => {
    return <Container>
        <ContentCardWrapper size={width}>
            <Content>
                <div dangerouslySetInnerHTML={{ __html: `${content}` }} />
            </Content>
            <StyledEffiePatternWrapper>
                <EffiePattern />
            </StyledEffiePatternWrapper>
        </ContentCardWrapper>
    </Container>
}

export default ContentCard
